var _path, _mask, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIllustrationMiniDiamondinline = function SvgIllustrationMiniDiamondinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.22 1h11.56a.2.2 0 0 1 .169.093l2.13 3.374a.2.2 0 0 1-.012.231l-7.91 9.982a.2.2 0 0 1-.314 0L.933 4.698a.2.2 0 0 1-.012-.231l2.13-3.374A.2.2 0 0 1 3.221 1Z",
    fill: "currentColor",
    fillOpacity: 0.2,
    stroke: "currentColor",
    strokeWidth: 0.556
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_835_2888",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 4.4H1v.4h16v-.4Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 4.4H1v.4h16v-.4Z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.4v-.556H.444V4.4H1Zm16 0h.556v-.556H17V4.4Zm0 .4v.556h.556V4.8H17Zm-16 0H.444v.556H1V4.8Zm0-.4v.556h16V3.844H1V4.4Zm16 0h-.556v.4h1.112v-.4H17Zm0 .4v-.556H1v1.112h16V4.8Zm-16 0h.556v-.4H.444v.4H1Z",
    fill: "currentColor",
    mask: "url(#path-2-inside-1_835_2888)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8 1 5.4 4.6 9 14.8M10.2 1l2.4 3.6L9 14.8",
    stroke: "currentColor",
    strokeWidth: 0.556
  })));
};
export default SvgIllustrationMiniDiamondinline;